import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import offlineService from './services/offline';

// Register Service Worker untuk PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Auto-reload ketika SW baru take over (MUST be BEFORE await registration
      // to catch immediate controllerchange when skipWaiting+clients.claim fire)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('🔄 PWA: New SW activated, reloading...');
        window.location.reload();
      });
      
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('✅ PWA: Service Worker registered');
      
      // Inisialisasi offline service
      await offlineService.init();
      
      // Bersihkan cache lama (lebih dari 7 hari)
      offlineService.clearOldCache();
      
      // Coba sync queue jika ada
      if (offlineService.isOnline()) {
        const result = await offlineService.syncQueue();
        if (result.synced > 0) {
          console.log(`✅ PWA: Synced ${result.synced} pending items`);
        }
      }
    } catch (error) {
      console.warn('❌ PWA: Service Worker registration failed:', error.message);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
